<template>
  <v-layout class="left-sidebar" column justify-start fill-height>
    <Title />
    <v-divider />
    <hierarchy />
    <v-divider />
    <user-info />
  </v-layout>
</template>

<script>
import Title from "@/components/Network/LeftSidebar/Title";
import Hierarchy from "@/components/Network/LeftSidebar/Hierarchy";
import UserInfo from "@/components/Network/LeftSidebar/UserInfo";
export default {
  name: "LeftSidebar",

  components: {
    UserInfo,
    Hierarchy,
    Title
  }
};
</script>

<style scoped>
.left-sidebar {
  position: absolute;
  width: 375px;
  z-index: 10;
  box-shadow: 3px 0 6px #00000029;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/LeftSidebar/LeftSidebar.vue